<template>
    <div id="document-page">
        <ToolbarComponent v-bind:title="$t('document_page.title')" />

        <v-tabs v-model="tab_selected" background-color="secondary" class="default-arrows-tabs" show-arrows slider-color="primary">
            <v-tab
                :class="(tab_selected === 'document-by-pro' ? '' : 'tab-opacity') + ' primary--text font-weight-bold '"
                href="#document-by-pro"
            >
                {{ $t('document_page.documents_by_pro', [$store.getters['user_connected/user_connected'].professional_name]) }}
            </v-tab>

            <v-tab
                v-if="!has_suiclean"
                :class="(tab_selected === 'document-by-user' ? '' : 'tab-opacity') + ' primary--text font-weight-bold '"
                href="#document-by-user"
            >
                {{ $t('document_page.documents_by_user') }}
            </v-tab>

            <v-tab-item class="background pa-4" value="document-by-pro">
                <DocumentByProDatatableComponent />
            </v-tab-item>

            <v-tab-item v-if="!has_suiclean" class="background pa-4" value="document-by-user">
                <DocumentByClientDatatableComponent />
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
import ToolbarComponent from '@/components/global/ToolbarComponent'
import DocumentByProDatatableComponent from '@/components/document/DocumentByProDatatableComponent.vue'
import DocumentByClientDatatableComponent from '@/components/document/DocumentByClientDatatableComponent.vue'

export default {
    name: 'DocumentPage',
    components: { DocumentByClientDatatableComponent, DocumentByProDatatableComponent, ToolbarComponent },
    data() {
        return {
            tab_selected: '',
        }
    },
    computed: {
        has_suiclean() {
            return this.$store.getters['asset_module/has_suiclean']
        },
    },
}
</script>
